import React, { useState } from 'react';
import { StyledFindLeads } from './FindLeads.styles';
import { GoArrowLeft } from 'react-icons/go';
import iconTick from '../../../assets/icon-tick.svg';
import Form from '../../molecules/Form/Form';
import { useForm } from '../../molecules/Form';
import Field from '../Field';
import Button from '../../molecules/Button';
import { IoLogoLinkedin } from 'react-icons/io';
import { useNavigate } from 'react-router-dom';
import linkedinService from '../../../services/linkedinService';
import Toast from '../../molecules/Toast';
import { useContextHook } from 'use-context-hook';
import { AuthContext } from '../../../Context/authContext';
import CenterModal from '../../molecules/Modal/CenterModal';
import LoginWithLinkedinModal from '../ProfileInfo/DetailsTab/LoginWithLinkedinModal';

const FindLeads = () => {
  const [activeTab, setActiveTab] = useState('linkedin_basic');
  const navigate = useNavigate();
  const [form] = useForm();
  const [loading, setLoading] = useState(false);
  const [linkedingLogin, setLinkedingLogin] = useState(false);
  const { refetch } = useContextHook(AuthContext, v => ({
    refetch: v.refetch,
  }));

  async function handleSubmit(e) {
    try {
      setLoading(true);
      const payload = {
        url: e?.url_link,
        numOfLeads: parseInt(e?.leads_to_scrape, 10) || 0,
        profileId: 5, // assume the profile id is 5 and it is in DB
      };
      const res = await linkedinService.linkedinScraping(payload);
      if (res?.success) {
        Toast({
          type: 'success',
          message: res.message,
        });
        refetch();
        navigate('/task');
      }
    } catch (error) {
      if (!error?.data?.linkedinLogin) {
        setLinkedingLogin(true);
        Toast({ type: 'error', message: error?.message || 'Something went wrong!' });
      } else {
        Toast({ type: 'error', message: error?.message || 'Something went wrong!' });
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <CenterModal open={linkedingLogin} setOpen={setLinkedingLogin} width={680} title="Login with Linkedin">
        <LoginWithLinkedinModal setLinkedingLogin={setLinkedingLogin} />
      </CenterModal>
      <StyledFindLeads>
        <div className="content-holder">
          <div className="head">
            <button onClick={() => window.history.back()}>
              <GoArrowLeft size={25} />
            </button>
            <div>
              <span className="heading">What do you want to Scrape?</span>
              <p>Select option and Provide Url</p>
            </div>
          </div>
          <span className="card-title">Please select how you want to proceed?</span>
          <div className="tabs-btns">
            <button
              type="button"
              className={`tabBtn ${activeTab === 'linkedin_basic' ? 'active' : ''}`}
              onClick={() => setActiveTab('linkedin_basic')}>
              <div className="btn-content">
                <div className="icon-box">
                  <IoLogoLinkedin size={25} />
                </div>
                <div className="text-box">
                  <span className="subtitle">Find leads</span>
                  <span className="title">LinkedIn Basic</span>
                </div>
                <div className="ico-tick">
                  <img src={iconTick} alt="tick" />
                </div>
              </div>
            </button>
            <button
              type="button"
              className={`tabBtn ${activeTab === 'linkedin_sales' ? 'active' : ''}`}
              onClick={() => setActiveTab('linkedin_sales')}>
              <div className="btn-content">
                <div className="icon-box">
                  <IoLogoLinkedin size={25} />
                </div>
                <div className="text-box">
                  <span className="subtitle">Find leads</span>
                  <span className="title">LinkedIn Sales Navigator</span>
                </div>
                <div className="ico-tick">
                  <img src={iconTick} alt="tick" />
                </div>
              </div>
            </button>
          </div>

          <Form form={form} onSubmit={handleSubmit}>
            <div className="input-holder">
              <div className="url-input">
                <Form.Item
                  label="Url Link"
                  type="text"
                  name="url_link"
                  placeholder="Put the URL of the search in..."
                  rules={[{ required: true, message: 'Url Is Required' }]}>
                  <Field />
                </Form.Item>
              </div>
              <Form.Item
                label="How many leads you want to scrape?"
                type="numeric"
                name="leads_to_scrape"
                placeholder="Enter leads to scrape"
                rules={[{ required: true, message: 'Leads Is Required' }]}>
                <Field />
              </Form.Item>
            </div>
            <span className="note">
              <span className="heading">Note:</span> The maximum lead scraping limit is 500 for basic LinkedIn
              accounts and 2000 for LinkedIn Sales Navigator.
            </span>
            <div className="btn-holder">
              <Button width="335px" loader={loading} type="submit" disabled={loading}>
                Scrape
              </Button>
            </div>
          </Form>
        </div>
      </StyledFindLeads>
    </>
  );
};

export default FindLeads;
